import { Box, Typography } from '@mui/material'
import { FormProps } from '@operations/app/models'
import { ControlledNumberField } from '@operations/components/form-controls'
import useFormWithSchema from '@operations/hooks/use-form-with-schema.hook'
import { useTranslate } from '@tolgee/react'
import { CustomInputAdornment, useMinimalsTheme } from '@tom-ui/ui'
import { useEffect } from 'react'
import { ProcessingTimeFormProfile, defaultValues } from './processing-time-form.profile'
import { schema } from './processing-time-form.scheme'

interface Props extends FormProps {
  processingTime?: number
  onSubmit: (formValues: ProcessingTimeFormProfile) => Promise<void> | void
}

export const ProcessingTime = ({ id, processingTime, onSubmit }: Props) => {
  const { handleSubmit, formState, control, reset } = useFormWithSchema<ProcessingTimeFormProfile>(
    schema(),
    defaultValues,
  )
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  useEffect(() => {
    if (processingTime) {
      reset({ processingTime: processingTime })
    }
  }, [reset, processingTime])

  return (
    <Box
      id={id}
      component='form'
      noValidate
      autoComplete='off'
      sx={{ gap: theme.customSpacing.l }}
      onSubmit={handleSubmit(onSubmit)}
    >
      <Typography
        variant='body1'
        color='secondary'
        mb={theme.customSpacing.s}
        data-cy='crane-split-edit-processing-time-message'
      >
        {t('editProcessingTimeMessage', 'Please edit the processing time for 1 container')}
      </Typography>
      <ControlledNumberField<ProcessingTimeFormProfile>
        name='processingTime'
        formState={formState}
        control={control}
        label={t('processingTime', 'Processing time')}
        endAdornment={
          <CustomInputAdornment position='end' color='secondary' padding={'24px'}>
            {t('minCnt', 'Min/cnt')}
          </CustomInputAdornment>
        }
        fullWidth
        dataCy='crane-split-edit-processing-time-input'
      />
    </Box>
  )
}
